import CardMedia from './CardMedia'
import { CardTierBadge } from './TierBadge'
import {
  CardElements,
  CardLink,
  TypeChip,
  hasMedia,
  mediaLimit,
  useCardTranslation,
  type TemplateProps,
} from './card-parts'

/**
 * Full-bleed photo with the name, price and meta on a gradient scrim. The scrim
 * needs a photo behind it to be readable, so a property with no photos (or
 * showImage off) falls back to the same content on the card surface.
 */
export default function TemplateOverlay({ property, options }: TemplateProps) {
  const { _t } = useCardTranslation(options)
  const media = hasMedia(property, options)

  const content = <CardElements property={property} options={options} template="overlay" />

  return (
    <div className="hr-pc-card hr-pc-card--overlay">
      <CardLink property={property} options={options} />
      {media ? (
        <CardMedia property={property} limit={mediaLimit(options)} aspectRatio={options.imageAspectRatio} t={_t}>
          <TypeChip property={property} options={options} />
          <CardTierBadge property={property} config={options.tierRating} at="media" />
          <div className={`hr-pc-scrim hr-pc-scrim--${options.overlayGradientStrength}`}>
            {content}
          </div>
        </CardMedia>
      ) : (
        <div className="hr-pc-body">
          <TypeChip property={property} options={options} />
          {content}
        </div>
      )}
    </div>
  )
}
